import { render, staticRenderFns } from "./salesPrePayAccount.vue?vue&type=template&id=3da22bdb&scoped=true"
import script from "./salesPrePayAccount.vue?vue&type=script&lang=js"
export * from "./salesPrePayAccount.vue?vue&type=script&lang=js"
import style0 from "./salesPrePayAccount.vue?vue&type=style&index=0&id=3da22bdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da22bdb",
  null
  
)

export default component.exports